<button type="button" attr.aria-label="{{ 'apply.filters' | translate | async }}"
    class="mt-1 ontario-button ontario-button--primary" 
    (click)="copyMetadataUrl(index, fileNumber)" [tabIndex]="0">
    {{ 'permanent.link' | translate | async }}
</button>